<template>
  <b-card>
    <b-row class="mt-2">
      <div class="mb-2">
        <b-button class="float-left" variant="primarySpore" @click="back()">Regresar</b-button>
      </div>
    </b-row>
    <div>
      <b-row class="mt-2">

        <b-col cols="12" md="4">
          <h3>Número: </h3>
          <h4>{{response.number}}</h4>
        </b-col>
        <b-col cols="12" md="4">
          <h4>Nombre: </h4>
          <h4>{{response.name}}</h4>
        </b-col>
        <b-col cols="12" md="4">
          <h4>Encargado: </h4>
          <h4>{{response.manager}}</h4>
        </b-col>

        <div class="col-12">
          <b-row>
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <h3>Listado Miembros de la Cuadrilla</h3>
            </b-col>

            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-end mb-1 mb-md-0">
              <div class="d-flex align-items-center">
                <b-button class="m-1" variant="primarySpore" @click="add()" v-b-tooltip.hover.top title="Agregar">
                  <feather-icon icon="PlusCircleIcon" :width="18" :height="18"/>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-col class="mt-2" cols="12" md="12">
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="this.responseTable"
            :fields="this.tableColumns"
            primary-key="id"
            show-empty
            empty-text="No hay registros"
          >
            <template #head(invoiceStatus)>
              <feather-icon
                icon="TrendingUpIcon"
                class="mx-auto"
              />
            </template>

            <template #cell(email)="data">
              <div class="text-left">
                <span class="text-nowrap">
                  {{ data.item.email }}
                </span>
              </div>
            </template>

            <template #cell(firstName)="data">
                <div class="text-center">
                  {{ data.item.firstName }}
                </div>
            </template>

            <template #cell(lastName)="data">
                <div class="text-center">
                  {{ data.item.lastName }}
                </div>
            </template>

            <template #cell(type)="data">
              <b-row>
                <b-col cols="12" md="12" class="custom-search d-flex justify-content-center">
                  <div class="text-center">
                    <listItem :value="(data.item.type === 'A' ? 'Administrador' : data.item.type === 'C' ? 'Administrador CFE' : data.item.type === 'S' ? 'Supervisor' : data.item.type === 'I' ? 'Instalador' : '')" description="Tipo" img="alias"/>
                  </div>
                </b-col>
              </b-row>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data" >
              <b-row>
                <b-col cols="12" md="12" class="custom-search d-flex justify-content-center">
                  <div class="d-flex align-items-center">
                    <b-button variant="danger" class="btn-icon p-1 ml-1" @click="unassingTeam(data.item.uuid)" title="Eliminar" v-b-tooltip.hover="{ placement: 'top' }">
                      <feather-icon icon="Trash2Icon" :width="18" :height="18" />
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </b-col>
        <br><br>
      </b-row>
    </div>

  </b-card>
</template>

<script>
// import { empty } from '@/libs/tools/helpers'
import listItem from '@core/spore-components/listItem/listItem.vue'
import {
  BButton, BRow, BCol, BCard, VBTooltip, BTable
} from 'bootstrap-vue'
import request from '@/libs/request/index'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BTable,
    listItem
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      uuid: this.$route.params.uuid,
      response: [],
      tableColumns: [
        { thClass: 'text-left', key: 'email', sortable: true, label: 'Correo Electrónico' },
        { thClass: 'text-center', key: 'firstName', sortable: true, label: 'Nombre(s)' },
        { thClass: 'text-center', key: 'lastName', sortable: true, label: 'Apellido(s)' },
        { thClass: 'text-center', key: 'type', sortable: true, label: 'Tipo' },
        { thClass: 'text-center', key: 'actions', label: 'Acciones' }
      ],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      responseTable: [],
      file: '',
      avatar: '',
      amortization: false,
      depreciation: false
    }
  },
  methods: {
    async unassingTeam (installer) {
      const params = {
        url: `users/assignTeam/${installer}`,
        method: 'PUT',
        params: {
          teamUuid: null
        }
      }
      await request(params).then(data => {
        this.getTeamsMembers()
      })
    },
    add () {
      this.$router.push(`/teams/${this.uuid}/addmembers`)
    },
    async getDetailTeam () {
      const params = {
        url: `/teams/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.response = data.data.data[0]
        }
      })
    },
    async getTeamsMembers () {
      const params = {
        url: `/teams/${this.uuid}/members`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.responseTable = data.data.data[0].cfeUsers
        }
      })
    },
    back () {
      this.$router.push('/teams')
    }
  },
  created () {
    this.getDetailTeam()
    this.getTeamsMembers()
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
